import React, { useMemo, useState } from "react";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../AtomStore/store";
import { fetchNews } from "../../QueryFunctions/queryfunction";
import NewsItem from "./Item";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";

import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import moment from "moment";
import Theme from "../../theme";

const NewsMobile = () => {
  const { useQueryWrapper } = useRequestProcessor();

  const [showModal, setShowModal] = useState(false);
  const [item, setItem] = useState();
  const [activeChild] = useAtom(activeChildDetail);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState({
    month: moment().format("MM"),
    year: moment().format("YYYY"),
  });

  const DEFAULT_FORMAT = "MMM DD, YYYY";

  const academicMonths = useMemo(() => {
    const months = [];
    const current = moment();
    const currentMonthIndex = current.month(); // 0-based
    const currentYear = current.year();
    let startYear = currentMonthIndex < 3 ? currentYear - 1 : currentYear;

    for (let i = 0; i < 12; i++) {
      const monthIndex = (3 + i) % 12; // April start
      const year = monthIndex < 3 ? startYear + 1 : startYear;

      if (
        year > currentYear ||
        (year === currentYear && monthIndex > currentMonthIndex)
      )
        break;

      months.push({
        label: moment().month(monthIndex).format("MMMM"),
        value: {
          month: String(monthIndex + 1).padStart(2, "0"),
          year: String(year),
        },
      });
    }
    return months;
  }, []);

  const { data: news, isLoading } = useQueryWrapper(
    ["news", activeChild?.id, selectedMonth],
    () => {
      console.log("[News Room] Calling API: /parentapp/getNewLetters ", {
        child_id: activeChild?.id,
        selectedMonth,
      });
      return fetchNews(selectedMonth);
    },
    {
      onSuccess: (data) => {
        console.log("[News Room] News Room  response:", data);
      },
    }
  );

  const validNews = Array.isArray(news)
    ? news.filter(
        (n) =>
          typeof n.notification_subject === "string" &&
          n.notification_subject.trim() !== ""
      )
    : [];

  const openModal = (show, item) => {
    setShowModal(show);
    setItem(item);
  };
  const toggle = () => {
    setShowModal(!showModal);
  };
  if (item) {
    // let htmlFile = item.notification_text;
    // let index = htmlFile.indexOf('<style type="text/css">');
    // let index1 = htmlFile.indexOf('</style>');
    // let styles =
    //   '<style type="text/css"> .red-clr{color:#EA4335;} .green-clr{color:#34A853;} .orange-clr{color:#fe6500;} .blue-clr{color:#56509F;} .gray-clr{color:#666;} .bg-grey{background:#f5f5f5;}' +
    //   'table {color:#555; line-height:30px;} .news-lettertable tr td {padding:0px 10px;} @media only screen and (max-width:800px) ' +
    //   '{ .wrapper{width:100% !important; border:none !important; display:flex; justify-content:center;} .orange-clr{color:#fe6500; line-height:normal; margin-top:7px} }' +
    //   //+ '@media only screen and (max-width:400px){ .wrapper{display:flex; justify-content:center; width:100% !important; border:none !important;} .orange-clr{} }'
    //   '</style>';
    // notification_text =
    //   htmlFile.substring(0, index) + styles + htmlFile.substring(index1 + 8);
  }

  const handleMonthChangeValue = (monthYearObj) => {
    setSelectedMonth(monthYearObj);
    setDropdownOpen(false);
  };
  return (
    <div>
      <div className="mb-3 pl-2 pt-4">
        <Dropdown
          isOpen={dropdownOpen}
          toggle={() => setDropdownOpen(!dropdownOpen)}
        >
          <DropdownToggle
            className="text-white"
            caret
            style={{
              backgroundColor: Theme.colorPrimary,
              border: "none",
              fontSize: "0.9em",
              padding: "6px 12px",
            }}
          >
            {moment(
              `${selectedMonth.year}-${selectedMonth.month}`,
              "YYYY-MM"
            ).format("MMMM")}
          </DropdownToggle>
          <DropdownMenu>
            {academicMonths.map((item, idx) => (
              <DropdownItem
                key={idx}
                onClick={() => handleMonthChangeValue(item.value)}
                className="font-weight-bold"
              >
                {item.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="mx-2 pb-4 pt-2 lg:grid lg:grid-cols-2 lg:gap-2 relative ">
        {isLoading ? <SpinnerLoading /> : ""}
        {validNews.length > 0 ? (
          validNews.map((item, index) => (
            <NewsItem
              key={index}
              openModal={(show, newsItem) => openModal(show, newsItem)}
              item={item}
            />
          ))
        ) : (
          <div className="text-center col-span-2">
            <ListEmptyComponent
              heading={isLoading ? "Loading..." : "No Data Found"}
            />
          </div>
        )}

        {item && (
          <Modal
            isOpen={showModal}
            toggle={toggle}
            className="modal-xl modal-dialog-scrollable"
          >
            <ModalHeader
              toggle={toggle}
              style={{ fontFamily: "Baloo", background: Theme.colorPrimary }}
            >
              <p className="text-white m-0">
                {moment(item.newsletter_sent_on).format(DEFAULT_FORMAT)}
              </p>
            </ModalHeader>
            <ModalBody
              dangerouslySetInnerHTML={{
                __html: item.notification_text,
              }}
            ></ModalBody>
          </Modal>
        )}

        {/* {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-auto my-6 mx-auto max-w-3xl">

              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    Modal Title
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                body
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-blueGray-500 text-lg leading-relaxed">
                    I always felt like I could do anything. That’s the main
                    thing people are controlled by! Thoughts- their perception
                    of themselves! They're slowed down by their perception of
                    themselves. If you're taught you can’t do anything, you
                    won’t do anything. I was taught I could do everything.
                  </p>
                </div>
                footer
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null} */}
      </div>
    </div>
  );
};

export default NewsMobile;
